export default __webpack_public_path__ + "static/media/warlord.3a712b93.png";